export const lexicon = [
  {
    id: "HAZARD",
    label: "HAZARD_DEF",
    ref: "UNDRR (Sendai Terminology, 2017)",
    url: "https://www.undrr.org/terminology/hazard",
  },
  {
    id: "HAZARD_TYPE",
    label: "HAZARD_TYPE_DEF",
    ref: "DASF",
  },
  {
    id: "DISASTER",
    label: "DISASTER_DEF",
    ref: "UNDRR (Sendai Terminology, 2017)",
    url: "https://www.undrr.org/terminology/disaster",
  },
  {
    id: "EMERGENCY",
    label: "EMERGENCY_DEF",
    ref: "WHO / IFRC practice",
  },
  {
    id: "DISASTER_RISK",
    label: "DISASTER_RISK_DEF",
    ref: "UNDRR (Sendai Terminology, 2017)",
    url: "https://www.undrr.org/terminology/disaster-risk",
  },
  {
    id: "EXPOSURE",
    label: "EXPOSURE_DEF",
    ref: "UNDRR (Sendai Terminology, 2017)",
    url: "https://www.undrr.org/terminology/exposure",
  },
  {
    id: "VULNERABILITY",
    label: "VULNERABILITY_DEF",
    ref: "UNDRR (Sendai Terminology, 2017)",
    url: "https://www.undrr.org/terminology/vulnerability",
  },
  {
    id: "CAPACITY",
    label: "CAPACITY_DEF",
    ref: "UNDRR (Sendai Terminology, 2017)",
    url: "https://www.undrr.org/terminology/capacity",
  },
  {
    id: "CAPABILITY",
    label: "CAPABILITY_DEF",
    ref: "DASF",
  },
  {
    id: "RESILIENCE",
    label: "RESILIENCE_DEF",
    ref: "UNDRR (Sendai Terminology, 2017)",
    url: "https://www.undrr.org/terminology/resilience",
  },
  {
    id: "PREVENTION",
    label: "PREVENTION_DEF",
    ref: "UNDRR (Sendai Terminology, 2017)",
    url: "https://www.undrr.org/terminology/prevention",
  },
  {
    id: "MITIGATION",
    label: "MITIGATION_DEF",
    ref: "UNDRR (Sendai Terminology, 2017)",
    url: "https://www.undrr.org/terminology/mitigation",
  },
  {
    id: "PREPAREDNESS",
    label: "PREPAREDNESS_DEF",
    ref: "UNDRR (Sendai Terminology, 2017)",
    url: "https://www.undrr.org/terminology/preparedness",
  },
  {
    id: "EARLY_WARNING_SYSTEM",
    label: "EARLY_WARNING_SYSTEM_DEF",
    ref: "UNDRR (Sendai Terminology, 2017)",
    url: "https://www.undrr.org/terminology/early-warning-system",
  },
  {
    id: "RESPONSE",
    label: "RESPONSE_DEF",
    ref: "UNDRR (Sendai Terminology, 2017)",
    url: "https://www.undrr.org/terminology/response",
  },
  {
    id: "RECOVERY",
    label: "RECOVERY_DEF",
    ref: "UNDRR (Sendai Terminology, 2017)",
    url: "https://www.undrr.org/terminology/recovery",
  },
  {
    id: "BUILD_BACK_BETTER",
    label: "BUILD_BACK_BETTER_DEF",
    ref: "UNDRR (Sendai Framework)",
    url: "https://www.undrr.org/terminology/build-back-better",
  },
  {
    id: "CONTINGENCY_PLANNING",
    label: "CONTINGENCY_PLANNING_DEF",
    ref: "UNDRR (Sendai Terminology, 2017)",
    url: "https://www.undrr.org/terminology/contingency-planning",
  },
  {
    id: "RISK_ASSESSMENT",
    label: "RISK_ASSESSMENT_DEF",
    ref: "UNDRR / ISO 31000",
  },
  {
    id: "RISK_COMMUNICATION",
    label: "RISK_COMMUNICATION_DEF",
    ref: "WHO / UNDRR practice",
  },
  {
    id: "SITUATION_AWARENESS",
    label: "SITUATION_AWARENESS_DEF",
    ref: "Emergency management practice",
  },
  {
    id: "INCIDENT_COMMAND",
    label: "INCIDENT_COMMAND_DEF",
    ref: "Incident command systems",
  },
  {
    id: "STAKEHOLDER",
    label: "STAKEHOLDER_DEF",
    ref: "DASF",
  },
  {
    id: "INTEROPERABILITY",
    label: "INTEROPERABILITY_DEF",
    ref: "DASF / standards practice",
  },
  {
    id: "CAPABILITY_GAP",
    label: "CAPABILITY_GAP_DEF",
    ref: "DASF",
  },
  {
    id: "CAPABILITY_ASSESSMENT",
    label: "CAPABILITY_ASSESSMENT_DEF",
    ref: "DASF",
  },
  {
    id: "SOLUTION",
    label: "SOLUTION_DEF",
    ref: "DASF",
  },
  {
    id: "SOLUTION_ASSESSMENT",
    label: "SOLUTION_ASSESSMENT_DEF",
    ref: "DASF",
  },
  {
    id: "ROADMAP",
    label: "ROADMAP_DEF",
    ref: "DASF",
  },
  {
    id: "IMPLEMENTATION_TIMELINE",
    label: "IMPLEMENTATION_TIMELINE_DEF",
    ref: "DASF",
  },
  {
    id: "PRIORITIZATION",
    label: "PRIORITIZATION_DEF",
    ref: "DASF",
  },
  {
    id: "MONITORING_EVALUATION",
    label: "MONITORING_EVALUATION_DEF",
    ref: "UNDRR / project management practice",
  },
  {
    id: "LESSONS_LEARNED",
    label: "LESSONS_LEARNED_DEF",
    ref: "Emergency management practice",
  },
  {
    id: "SESSION",
    label: "SESSION_DEF",
    ref: "DASF",
  },
  {
    id: "COMPLIANCE_CHECK",
    label: "COMPLIANCE_CHECK_DEF",
    ref: "DASF",
  },
  {
    id: "TECHNOLOGY_READINESS_LEVEL",
    label: "TECHNOLOGY_READINESS_LEVEL_DEF",
    ref: "TRL framework",
  },
];
